<i18n src="./i18n/index.json"></i18n>

<template>
  <div class="homepage-wrapper" ref="content">
    <!--<h1>{{ $t('title') }}</h1>-->
    <div class="holder">
      <div class="panel-left">
        <div class="form-group">
          <label>{{ $t('waste_label') }}</label>
          <select class="form-control" v-model="selectedWaste" @change="setWasteType">
            <option
              v-for="waste in wasteList"
              :value="waste.atik_id">{{ waste.hammadde }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{ $t('amount_label') }}</label>
          <div class="checkbox-holder mb-10">
            <div class="radio">
              <label for="selectedAmountType1">
                <input
                  type="radio"
                  name="selectedAmountType"
                  id="selectedAmountType1"
                  class="form-control"
                  value="Yıllık"
                  @change="selectedAnimalAmount = ''"
                  v-model="selectedAmountTimeType">
                <span></span>
                {{ $t('yearly') }}
              </label>
            </div>
            <div class="radio">
              <label for="selectedAmountType2">
                <input
                  type="radio"
                  name="selectedAmountType"
                  id="selectedAmountType2"
                  class="form-control"
                  value="Günlük"
                  v-model="selectedAmountTimeType">
                <span></span>
                {{ $t('daily') }}
              </label>
            </div>
          </div>
          <div class="checkbox-holder mb-20" v-if="selectedAmountTimeType !== ''">
            <div class="radio">
              <label for="selectedMassType1">
                <input
                  type="radio"
                  name="selectedMassType"
                  id="selectedMassType1"
                  class="form-control"
                  value="Ton"
                  v-model="selectedAmountMassType">
                <span></span>
                {{ $t('tonne') }}
              </label>
            </div>
            <div class="radio">
              <label for="selectedMassType2">
                <input
                  type="radio"
                  name="selectedMassType"
                  id="selectedMassType2"
                  class="form-control"
                  value="Kg"
                  v-model="selectedAmountMassType">
                <span></span>
                Kg
              </label>
            </div>
          </div>
          <div v-if="selectedAmountMassType !== ''">
            <p class="label-helper">{{ $t('enter_waste_amount') }}</p>
            <input
              type="number"
              class="form-control"
              v-model="selectedAmount">
          </div>
          <div v-if="selectedWasteType === 'Animal'" class="mt-20">
            <label>{{ $t('animal_amount') }}</label>
            <input
              type="number"
              class="form-control"
              @focus="resetOtherAmounts"
              v-model="selectedAnimalAmount">
          </div>
        </div>
        <button class="btn btn-full btn-blue" @click="addWasteToUserWasteList" :disabled="selectedAmount === '' && selectedAnimalAmount ===''">{{ $t('add') }}</button>

        <div class="user-waste-list" v-if="userWasteList.length">
          <h3>{{ $t('waste_list') }}</h3>
          <ul>
            <li v-for="(userWaste, index) in userWasteList" v-bind:style="{ backgroundColor: userWaste.color}">
              <span>
                <span class="name">{{ userWaste.hammadde }}</span>
                <em>{{ userWaste.miktar }} {{ userWaste.birim_kutle_2 }}/{{ userWaste.birim_zaman_2 }}</em>
              </span>
              <a href="javascript:;" @click="removeWaste(index)"> <img src="static/close.svg"></a>
            </li>
          </ul>
        </div>
        <!--<pre>{{userWasteList}}</pre>-->
      </div>
      <div class="content-area" ref="reportContent">
        <div class="container" v-if="visibleSection === 'report'">
          <div class="title-wrapper mb-20">
            <h2>{{ $t('production_values') }}</h2>
            <button @click="downloadPDF" class="btn btn-blue">{{ $t('download_pdf')}}</button>
          </div>
          <div class="row mb-40">
            <div class="col-4">
              <div class="result-widget">
                <h3>{{ $t('methane_potential') }}</h3>
                <p>{{ methanePotential.toFixed(2) }} <span>m3 / {{ $t('year') }}</span></p>
              </div>
            </div>
            <div class="col-4">
              <div class="result-widget">
                <h3>{{ $t('electricity_generation') }}</h3>
                <p>{{ electricityGeneration.toFixed(2) }} <span>kwh / {{ $t('year') }}</span></p>
              </div>
            </div>
            <div class="col-4">
              <div class="result-widget">
                <h3>{{ $t('installed_capacity') }}</h3>
                <p>{{ electricityGeneration.toFixed() / 8000 }} <span>kwh</span></p>
              </div>
            </div>
          </div>

          <h2 class="mb-20">{{ $t('proportional_evaluation') }}</h2>
          <div class="row mb-30">
            <div class="col-6">
              <div class="result-widget">
                <h3>{{ $t('electricity_generation') }}</h3>
                <div class="electricity-potential">
                  <apexcharts
                    width="100%"
                    height="350"
                    type="bar"
                    ref="electrictyPotentialChart"
                    :options="electricityPotentialChartOptions"
                    :series="electricityPotentialChartSeries"></apexcharts>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="result-widget">
                <h3>{{ $t('amount_of_waste') }}</h3>
                <div class="waste-amount">
                  <apexcharts
                    width="100%"
                    height="350"
                    type="bar"
                    ref="wasteAmountChart"
                    :options="wasteAmountChartOptions"
                    :series="wasteAmountChartSeries"></apexcharts>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="result-widget">
                <h3>{{ $t('electricity_generation') }}</h3>
                <div class="electricity-potential-pie">
                  <apexcharts
                    type="pie"
                    width="100%"
                    ref="electrictyPotentialPieChart"
                    :options="electricityPotentialPieChartOptions"
                    :series="electricityPotentialPieChartSeries">
                  </apexcharts>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="result-widget">
                <h3>{{ $t('amount_of_waste') }}</h3>
                <div class="waste-amount-pie">
                  <apexcharts
                    type="pie"
                    width="100%"
                    ref="wasteAmountPieChart"
                    :options="wasteAmountPieChartOptions"
                    :series="wasteAmountPieChartSeries">
                  </apexcharts>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import VueApexCharts from 'vue-apexcharts'
  import jsPDF from 'jspdf'
  import html2canvas from 'html2canvas'

  Vue.use(VueAxios, axios)

  export default {
    name: 'About',
    components: {
      apexcharts: VueApexCharts
    },
    data () {
      return {
        wasteList: [],
        selectedWaste: '',
        selectedWasteType: '',
        selectedAmountTimeType: '',
        selectedAmountMassType: '',
        selectedAmount: '',
        selectedAnimalAmount: '',
        userWasteList: [],
        color: '#000000',
        methanePotential: 0,
        electricityGeneration: 0,
        installedCapacity: '',
        visibleSection: 'form',
        electricityPotentialChartSeries: [{
          data: []
        }],
        wasteAmountChartSeries: [{
          data: []
        }],
        electricityPotentialChartOptions: {
          plotOptions: {
            bar: {
              barHeight: '100%',
              distributed: true,
              horizontal: false,
              dataLabels: {
                position: 'bottom'
              },
            }
          },
          colors: [],
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#fff']
            },
            formatter: function (val, opt) {
              //return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              return val
            },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },

          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              show: true
            }
          },
          title: {
            text: 'Elektrik Üretimi (kWh / ton)',
            align: 'center',
            floating: true
          },
          subtitle: {
            text: '',
            align: 'center'
          },
          tooltip: {
            theme: 'dark',
            x: {
              show: false
            },
            y: {
              title: {
                formatter: function () {
                  return ''
                }
              }
            }
          }
        },
        wasteAmountChartOptions: {
          plotOptions: {
            bar: {
              barHeight: '100%',
              distributed: true,
              horizontal: false,
              dataLabels: {
                position: 'bottom'
              },
            }
          },
          colors: [],
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#fff']
            },
            formatter: function (val, opt) {
              //return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              return val
            },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },

          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              show: true
            }
          },
          title: {
            text: 'Atık Miktarı (ton/yıl)',
            align: 'center',
            floating: true
          },
          subtitle: {
            text: '',
            align: 'center'
          },
          tooltip: {
            theme: 'dark',
            x: {
              show: false
            },
            y: {
              title: {
                formatter: function () {
                  return ''
                }
              }
            }
          }
        },
        electricityPotentialPieChartSeries: [],
        electricityPotentialPieChartOptions: {
          labels: [],
          colors: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
        wasteAmountPieChartSeries: [],
        wasteAmountPieChartOptions: {
          labels: [],
          colors: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    },
    mounted () {
      let formData = new FormData()

      formData.append('action', 'get_ajax_posts')
      Vue.axios.post('http://pales.com.tr/wp-admin/admin-ajax.php', formData).then((response) => {
        this.wasteList = response.data
      })

      let leadFormData = new FormData()
      leadFormData.append('action', 'get_leads')
      Vue.axios.post('http://pales.com.tr/wp-admin/admin-ajax.php', leadFormData).then((response) => {
        let userToken = this.$route.params.token
        var i
        for (i = 0; i < response.data.length; i++) {
          if (response.data[i].token === userToken) {
            this.userWasteList = response.data[i].wasteList
            this.visibleSection = 'report'
            this.calculateProductionValues()
          }
        }
      })
    },
    watch: {
      '$route' (to, from) {
        let userData = JSON.parse(localStorage.getItem('userData'))
        if (userData.token === this.$route.params.token) {
          this.visibleSection = 'report'
          this.userWasteList = userData.userWasteList
          this.calculateProductionValues()
        }
        else {
          this.$router.push('/')
        }
      }
    },
    methods: {
      addWasteToUserWasteList () {
        this.generator()
        let item = this.wasteList.find(item => item.atik_id === this.selectedWaste)

        if(this.selectedAnimalAmount !== '') {
          item.miktar = (this.selectedAnimalAmount * item.atik_uretimi) * 365 / 1000
        }
        else {
          if(this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Ton') {
            item.miktar = this.selectedAmount
          }
          else if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Kg') {
            item.miktar = this.selectedAmount * 0.001
          }
          else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Ton') {
            item.miktar = this.selectedAmount * 365
          }
          else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Kg') {
            item.miktar = (this.selectedAmount * 365) / 1000
          }
        }
        item.color = this.color
        this.userWasteList.push(item)
        this.calculateProductionValues()
      },
      calculateProductionValues () {
        //console.log(this.userWasteList)
        this.methanePotential = 0
        this.electricityGeneration = 0
        let i

        // Reset potential chart data
        this.electricityPotentialChartSeries[0].data = []
        this.electricityPotentialChartOptions.xaxis.categories = []
        this.electricityPotentialChartOptions.colors = []
        // -- Pie Chart
        this.electricityPotentialPieChartSeries = []
        this.electricityPotentialPieChartOptions.labels = []
        this.electricityPotentialPieChartOptions.colors = []

        // Reset waste amount chart data
        this.wasteAmountChartSeries[0].data = []
        this.wasteAmountChartOptions.xaxis.categories = []
        this.wasteAmountChartOptions.colors = []
        // -- Pie Chart
        this.wasteAmountPieChartSeries = []
        this.wasteAmountPieChartOptions.labels = []
        this.wasteAmountPieChartOptions.colors = []

        for (i = 0; i < this.userWasteList.length; i++) {
          this.methanePotential += parseFloat(this.userWasteList[i].metan_potansiyeli.replace(',', '.')) * parseFloat(this.userWasteList[i].miktar)
          this.electricityGeneration += parseFloat(this.userWasteList[i].elektrik_potansiyeli.replace(',', '.')) * parseFloat(this.userWasteList[i].miktar)

          // Electricity potential chart data
          let selectedWasteElectricityGeneration = parseFloat(this.userWasteList[i].elektrik_potansiyeli) * parseFloat(this.userWasteList[i].miktar)
          this.electricityPotentialChartSeries[0].data.push(parseFloat(selectedWasteElectricityGeneration))
          this.electricityPotentialChartOptions.xaxis.categories.push(this.userWasteList[i].hammadde)
          this.electricityPotentialChartOptions.colors.push(this.userWasteList[i].color)
          // -- Pie Chart
          this.electricityPotentialPieChartSeries.push(parseFloat(selectedWasteElectricityGeneration))
          this.electricityPotentialPieChartOptions.labels.push(this.userWasteList[i].hammadde)
          this.electricityPotentialPieChartOptions.colors.push(this.userWasteList[i].color)

          // Waste amount chart data
          let selectedWasteAmount = parseFloat(parseFloat(this.userWasteList[i].miktar))
          this.wasteAmountChartSeries[0].data.push(selectedWasteAmount)
          this.wasteAmountChartOptions.xaxis.categories.push(this.userWasteList[i].hammadde)
          this.wasteAmountChartOptions.colors.push(this.userWasteList[i].color)
          // -- Pie Chart
          this.wasteAmountPieChartSeries.push(selectedWasteAmount)
          this.wasteAmountPieChartOptions.labels.push(this.userWasteList[i].hammadde)
          this.wasteAmountPieChartOptions.colors.push(this.userWasteList[i].color)

          this.selectedAmount = ''
          this.selectedAmountTimeType = ''
          this.selectedAmountMassType = ''
          this.selectedWaste = ''
          this.selectedAnimalAmount = ''
        }
        let self = this
        Vue.nextTick(function () {
          // Update electricity potential chart data
          self.$refs.electrictyPotentialChart.updateOptions({ xaxis: {categories:self.electricityPotentialChartOptions.xaxis.categories} })
          self.$refs.electrictyPotentialChart.updateOptions({ colors: self.electricityPotentialChartOptions.colors })
          // -- Pie Chart
          self.$refs.electrictyPotentialPieChart.updateOptions({ labels: self.electricityPotentialPieChartOptions.labels })
          self.$refs.electrictyPotentialPieChart.updateOptions({ colors: self.electricityPotentialPieChartOptions.colors })

          // Update amount chart data
          self.$refs.wasteAmountChart.updateOptions({ xaxis: {categories:self.wasteAmountChartOptions.xaxis.categories} })
          self.$refs.wasteAmountChart.updateOptions({ colors: self.wasteAmountChartOptions.colors })
          // -- Pie Chart
          self.$refs.wasteAmountPieChart.updateOptions({ labels: self.wasteAmountPieChartOptions.labels })
          self.$refs.wasteAmountPieChart.updateOptions({ colors: self.wasteAmountPieChartOptions.colors })
        })
      },
      generator: function (event) {
        this.color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
      },
      removeWaste (wasteID) {
        this.userWasteList.splice(wasteID, 1)
        this.calculateProductionValues()
      },
      setWasteType() {
        let animalWasteList = ['66' , '67', '68', '69', '70', '71' , '72' , '73']
        if(animalWasteList.includes(this.selectedWaste)) {
          this.selectedWasteType = 'Animal'
        }
        else {
          this.selectedWasteType = 'Other'
        }
      },
      resetOtherAmounts () {
        this.selectedAmountTimeType = ''
        this.selectedAmountMassType = ''
        this.selectedAmount = ''
      },
      generateToken (length) {
        var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
        var b = [];
        for (var i=0; i<length; i++) {
          var j = (Math.random() * (a.length-1)).toFixed(0);
          b[i] = a[j];
        }
        return b.join("");
      },
      downloadPDF () {
        let reportHeight = this.$refs.reportContent.clientHeight
        let reportWidth = this.$refs.reportContent.clientWidth
        let orientation
        if (window.screen.width < 678) {
          orientation = 'portrait'
        }
        else {
          orientation = 'landscape'
        }
        const doc = new jsPDF ({
          orientation: orientation,
          unit: 'px',
          format: [reportWidth, reportHeight]
        })
        /** WITH CSS */
        var canvasElement = document.createElement('canvas')
        html2canvas(this.$refs.reportContent, {
          canvas: canvasElement,
          scale: 3
        }).then(function (canvas) {
          const img = canvas.toDataURL("image/png")
          doc.addImage(img, 'JPEG', 0, 0, reportWidth/2, reportHeight/2)
          doc.save("pales_report.pdf")
        })
      }
    }
  }
</script>

<style lang="scss">
  .title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/pages/About/index.vue